import React, { useContext, useState } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { useHistory, useParams } from 'react-router-dom';
import gql from 'graphql-tag';
import { AccountContext } from '../../../../../components/AccountContext';
import SurveyProjectImport from './components/SurveyProjectImport';
import { NotificationContext } from '../../../../../components/GrowlNotifications';
import { growlErrors } from '../../../../../utils/NotificationUtil';
import SurveyImportNotice from './SurveyImportNotice';
import { getErrors } from '../../../../../utils/ApolloGraphqlUtil';

const IMPORT_QUERY = gql`
  mutation($input: SurveyDefinitionsImportInput!) {
    importFile: importSurveyProjectDefinitions(input: $input) {
      id
      status
      messages
      fileName
    }
  }
`;

const DEFAULT_STATE = {
  numberOfInternalRespondentsOfImport: 0,
  numberOfInternalRespondentsThatCanBeAdded: 0,
};

const ImportContainer = () => {
  const [errorDialogData, setErrorDialogData] = useState(DEFAULT_STATE);

  const history = useHistory();
  const { surveyProjectId } = useParams();
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const [importFile] = useMutation(IMPORT_QUERY, {
    refetchQueries: ['surveyProjectFileList'],
  });
  const onUpload = async (files) => {
    const file = files[0];
    try {
      const result = await importFile({
        variables: {
          input: {
            accountId: currentAccount,
            surveyProjectId,

            // for using file drop component, the field name need to be mapped
            // to the input id, in this case, it's always 1
            fieldName: '1',
          },
          file,
        },
      });
      const { id } = result.data.importFile;
      history.push(`/accounts/${currentAccount}/survey-projects/${surveyProjectId}/imports/${id}`);
    } catch (errors) {
      handleImportError(errors);
    }
  };

  const hideDialog = () => {
    setErrorDialogData(DEFAULT_STATE);
  };

  const handleErrorThrownDueToInternalRespondents = (processedErrors) => {
    const numberOfInternalRespondentsOfImport = processedErrors[0].extensions.numberOfInternalRespondentsOfImport;
    const numberOfInternalRespondentsThatCanBeAdded =
      processedErrors[0].extensions.numberOfInternalRespondentsThatCanBeAdded;

    const errorData = {
      numberOfInternalRespondentsOfImport,
      numberOfInternalRespondentsThatCanBeAdded,
    };

    setErrorDialogData(errorData);
  };

  const wasErrorThrownDueToInternalRespondents = (processedErrors) => {
    return (
      processedErrors[0] &&
      processedErrors[0].extensions.numberOfInternalRespondentsOfImport > 0 &&
      processedErrors[0].extensions.numberOfInternalRespondentsThatCanBeAdded > 0
    );
  };

  const handleImportError = (errors) => {
    const processedErrors = getErrors(errors);

    const errorWasThrownDueToInternalRespondents = wasErrorThrownDueToInternalRespondents(processedErrors);

    if (errorWasThrownDueToInternalRespondents) {
      handleErrorThrownDueToInternalRespondents(processedErrors);
    } else {
      growlErrors(growl, errors);
    }
  };

  const { numberOfInternalRespondentsOfImport, numberOfInternalRespondentsThatCanBeAdded } = errorDialogData;

  return (
    <>
      <SurveyImportNotice
        numberOfInternalRespondentsOfImport={numberOfInternalRespondentsOfImport}
        numberOfInternalRespondentsThatCanBeAdded={numberOfInternalRespondentsThatCanBeAdded}
        hideDialog={hideDialog}
      />
      <SurveyProjectImport onUpload={(files) => onUpload(files)} />
    </>
  );
};

export default ImportContainer;
